import { render, staticRenderFns } from "./notFound.vue?vue&type=template&id=27f4436c&"
import script from "./notFound.vue?vue&type=script&lang=ts&"
export * from "./notFound.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports